<template>
  <c-view>
    <c-page>
      <div class="bg-linear"></div>
      <img class="flex-people" src="../../assets/images/confirmOrder/flex-people.png" alt="">
      <c-content>
        <div class="product flex">
          <div class="left shopwindow-svg"></div>
          <div class="right flex">
            <div >
              <div class="chuchuang">手机橱窗</div>
              <span class="info-box">
                <span class="zhe">折</span>
                <span class="zhe-bg">7折优惠</span>
                <span>
                  <span class="grey">能卖货</span>
                  <span class="grey">能获客</span>
                  <span class="grey">高性价比</span>
                </span>
              </span>
            </div>
            <div class="flex info-bottom">
              <span class="grey-bottom">已选：终身版</span>
              <span>
                <span class="grey-bottom delline">¥1245</span>
                <span class="orange-bottom">¥<span>4288</span></span>
              </span>
            </div>
          </div>
        </div>
        <c-cell-container>
          <c-cell-checkbox
            v-for="(item,index) in payTypeGroup"
            :key="index"
            :value="item.isChecked"
            :class="{'disabled': item.isAvailable}"
            @input="val => checkChange(val,item)"
            :point="false"
          >
            <div class="goods-icon" slot="header" >
              <img class="payoff-img" :src="item.icon" alt="">
            </div>
            <div class="ml-5 text-elps goods-desc" slot="body">
              <div>{{item.name}}</div>
            </div>
          </c-cell-checkbox>
          <div class="stages flex">
            <div class="col" v-for="(item,index) in payStagesGroup" :key="index" :class="{'active': item.isChecked}" @click="handleStages(index)">
              <div class="number">{{item.NumberName}}</div>
              <div class="commission">手续费{{item.commission}}</div>
            </div>
          </div>
          
        </c-cell-container>
      </c-content>
      <c-footer>
        <div class="footer flex">
          <div class="left-info flex">
            <span class="gold">
              <span class="bold">¥</span><span class="big">3288</span>
            </span>
            <span class="gold small delline">¥3687</span>
            <span>
              <span class="gold small">省</span>
              <span class="red small">¥399</span>
            </span>
          </div>
          <div class="payoff-button">
            <div class="button">确认支付</div>
            <div class="button-bg"></div>
          </div>
        </div>
      </c-footer>
    </c-page>
  </c-view>
</template>

<script>
export default {
  name: 'confirmOrder',
  data () {
    return {
      payStagesGroup: [
        {NumberName: '¥3444.00 x 3期', commission: 0, isChecked: true},
        {NumberName: '¥166.50 x 6期', commission: 0, isChecked: false}
      ],
      payTypeGroup: [
        {name: '微信支付', icon: require('../../assets/images/confirmOrder/payoff1.png'), isChecked: false},
        {name: '支付宝支付', icon: require('../../assets/images/confirmOrder/payoff2.png'), isChecked: false},
        {name: '花呗免息分期', icon: require('../../assets/images/confirmOrder/payoff3.png'), isChecked: true}
      ]
    }
  },
  mounted () {

  },
  methods: {
    checkChange (val, item) {
      this.payTypeGroup.forEach(cItem => {
        cItem.isChecked = cItem === item
      })
    },
    handleStages (index) {
      this.payStagesGroup.forEach(cItem => {
        cItem.isChecked = false
      })
      this.payStagesGroup[index].isChecked = true
    }

  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>



// WEBPACK FOOTER //
// index.vue?f38c7a76